import { BusinessChallengesEnum } from '@platform/client/schemas';
import { FormsInputDropdown, FormsMultilineInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageContent } from '../../application/components/ApplicationPageContent';
import BackgroundImage from '../../application/images/Leftsection8.svg';
import { ChallengeFormPageProps, challengeOptions } from './consts';
import { BusinessChallenges } from '@platform/client';
import { useQueryClient } from '@tanstack/react-query';
import { ChallengeFormBackground } from './ChallengeFormBackground';

type FormValues = {
  secondBusinessChallenge: BusinessChallengesEnum | null;
  secondBusinessChallengeDescription: string | null;
};

export const OrganizationChallengeTwo = (props: ChallengeFormPageProps) => {
  const { onBack, onContinue, challengeData, organizationId } = { ...props };

  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      secondBusinessChallenge: challengeData?.challengeTwo?.challenge as BusinessChallengesEnum,
      secondBusinessChallengeDescription: challengeData?.challengeTwo?.challengeContext,
    },
  });

  const queryClient = useQueryClient();
  const updateChallengeMutator = BusinessChallenges.useUpdateOrganizationBusinessChallenge({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: BusinessChallenges.getGetOrganizationBusinessChallengesQueryKey(organizationId),
        });
      },
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateChallengeMutator.mutate({
      organizationId: props.organizationId,
      data: {
        challenge: {
          challenge_number: 2,
          challenge_value: data.secondBusinessChallenge,
          challenge_context: data.secondBusinessChallengeDescription,
        },
      },
    });
  };

  return (
    <ChallengeFormBackground
      onBack={onBack}
      onSubmit={handleSubmit(submit)}
      onContinue={onContinue}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent title='Tell us about your second biggest challenge'>
        <FormsInputDropdown
          control={control}
          name='secondBusinessChallenge'
          label='Second business challenge'
          placeholder='Select your second challenge'
          items={challengeOptions}
          type='default'
          error={errors.secondBusinessChallenge}
        />
        <FormsMultilineInput
          control={control}
          label='Tell us more about this challenge'
          placeholder='Enter a description...'
          name={'secondBusinessChallengeDescription'}
          formsError={errors.secondBusinessChallengeDescription}
          characterCount={500}
        />
      </ApplicationPageContent>
    </ChallengeFormBackground>
  );
};
